<template>
  <div class="separator">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import 'variables';

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0.5rem 0;
  color: $primary-gray;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid $primary-gray;
}

.separator:not(:empty)::before {
  margin-right: 1.25em;
}

.separator:not(:empty)::after {
  margin-left: 1.25em;
}
</style>
